export default {"src":"//_next/static/media/clove.657c6fc5.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};